import { render, staticRenderFns } from "./PictureQuestion.vue?vue&type=template&id=79da54ba"
import script from "./PictureQuestion.vue?vue&type=script&lang=js"
export * from "./PictureQuestion.vue?vue&type=script&lang=js"
import style0 from "./PictureQuestion.vue?vue&type=style&index=0&id=79da54ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports